export const getPortalRoot = (): HTMLElement => {
  const container = document.getElementById("portal-root");
  if (!container) {
    console.error(`Target element "#portal-root" is not in dom`);

    return document.body;
  }
  return container;
};
